/** Average calendar lengths; the reporting academic year runs September–June. */
const DAYS_PER_MONTH = 365.25 / 12;
const DAYS_PER_SEMESTER = 5 * DAYS_PER_MONTH;
const DAYS_PER_ACADEMIC_YEAR = 2 * DAYS_PER_SEMESTER;
const DAYS_PER_WEEK = 7;
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

/** Ordered highest cadence first: each active user belongs to at most one tier. */
export const FREQUENCY_TIERS = [
    {
        tier: "FREQUENT",
        label: "Frequent",
        description: "at least a couple times per week on average",
        daysPerActivity: DAYS_PER_WEEK / 2,
    },
    { tier: "WEEKLY", label: "Weekly", description: "at least once a week on average", daysPerActivity: DAYS_PER_WEEK },
    {
        tier: "MONTHLY",
        label: "Monthly",
        description: "at least once a month on average",
        daysPerActivity: DAYS_PER_MONTH,
    },
    {
        tier: "SEMESTERLY",
        label: "Semesterly",
        description: "at least once a semester on average",
        daysPerActivity: DAYS_PER_SEMESTER,
    },
    {
        tier: "YEARLY",
        label: "Yearly",
        description: "at least once per academic year",
        daysPerActivity: DAYS_PER_ACADEMIC_YEAR,
    },
] as const;

/** Distinct active days divided by the report duration, with a one-day minimum. */
export const tierByDaysActive = (rows: { userId: string; daysActive: number }[], from: Date, to: Date) => {
    const windowDays = Math.max(1, (to.getTime() - from.getTime()) / MILLISECONDS_PER_DAY);
    const counts = FREQUENCY_TIERS.map((definition) => ({ tier: definition.tier, userCount: 0 }));
    for (const row of rows) {
        const index = FREQUENCY_TIERS.findIndex(
            (definition) => row.daysActive * definition.daysPerActivity >= windowDays,
        );
        const matched = counts[index];
        if (matched) matched.userCount += 1;
    }
    return counts;
};
